/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import {
  Modal,
  Button,
  Box,
  TextField,
  Card,
  CardContent,
  CardActions,
  CardHeader,
  IconButton,
  InputAdornment,
  MenuItem
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import ContentLoader from '../../utils/errorPages/ContentLoader';
import globalAction from '../../store/actions/GlobalAction';
import UomAction from '../../store/actions/UomAction';

function UOMView({ itemId, openmodal, onCloseModal }) {
  /* Modal Style */

  const dispatch = useDispatch();

  // Replace 'data' with your reducer name
  const { uomItemData, isLoading } = useSelector((state) => state.uom);
  const { statusData } = useSelector((state) => state.global);

  useEffect(() => {
    dispatch(UomAction.getItem(itemId));
    dispatch(globalAction.getClientStatus());
  }, [dispatch, itemId]);

  const initialValues = {
    name: uomItemData && uomItemData.name ? uomItemData.name : '',
    status: uomItemData && uomItemData.status ? uomItemData.status : '',
    short_name: uomItemData && uomItemData.short_name ? uomItemData.short_name : ''
  };

  return (
    <Modal
      className="cmn__form__modal"
      open={openmodal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box>
        {isLoading ? <ContentLoader /> : ''}
        <Formik initialValues={initialValues} enableReinitialize onSubmit={{}}>
          {({ values, handleChange, handleBlur, handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <Card>
                <CardHeader
                  title="View UOM"
                  action={
                    <IconButton
                      aria-label="settings"
                      onClick={() => {
                        onCloseModal();
                      }}
                    >
                      <Close />
                    </IconButton>
                  }
                />
                <CardContent>
                  <TextField
                    id="name"
                    fullWidth
                    label="UOM Name"
                    disabled
                    name="name"
                    margin="normal"
                    placeholder="Enter UOM Name"
                    value={values.name}
                    onChange={handleChange}
                    onBlur={(e) => {
                      handleBlur(e);
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">
                          <IconButton
                            aria-label="toggle password visibility"
                            edge="end"
                            disabled
                            sx={{
                              bgcolor: 'secondary.main',
                              borderRadius: '5px',
                              '&.Mui-disabled': {
                                bgcolor: 'secondary.main'
                              },
                              '&:hover': {
                                borderColor: 'secondary.main',
                                borderWidth: '1px',
                                borderStyle: 'solid'
                              }
                            }}
                            // color="secondary"
                          >
                            <i className="icon-measure" />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                  <TextField
                    id="short_name"
                    fullWidth
                    label="UOM Short Name"
                    name="short_name"
                    margin="normal"
                    disabled
                    placeholder="Enter UOM Short Name"
                    value={values.short_name}
                    onChange={handleChange}
                    onBlur={(e) => {
                      handleBlur(e);
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">
                          <IconButton
                            aria-label="toggle password visibility"
                            edge="end"
                            disabled
                            sx={{
                              bgcolor: 'secondary.main',
                              borderRadius: '5px',
                              '&.Mui-disabled': {
                                bgcolor: 'secondary.main'
                              },
                              '&:hover': {
                                borderColor: 'secondary.main',
                                borderWidth: '1px',
                                borderStyle: 'solid'
                              }
                            }}
                            // color="secondary"
                          >
                            <i className="icon-measure" />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                  <TextField
                    id="status"
                    fullWidth
                    label="Status"
                    name="status"
                    margin="normal"
                    select
                    disabled
                    value={values.status}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">
                          <IconButton
                            aria-label="toggle password visibility"
                            edge="end"
                            disabled
                            sx={{
                              bgcolor: 'secondary.main',
                              borderRadius: '5px',
                              '&.Mui-disabled': {
                                bgcolor: 'secondary.main'
                              },
                              '&:hover': {
                                borderColor: 'secondary.main',
                                borderWidth: '1px',
                                borderStyle: 'solid'
                              }
                            }}
                            // color="secondary"
                          >
                            <i className="icon-arrow-down" />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  >
                    {statusData &&
                      statusData.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.status}
                        </MenuItem>
                      ))}
                  </TextField>
                </CardContent>
                <CardActions sx={{ justifyContent: 'center' }}>
                  <Button
                    type="button"
                    className="cancel__btn"
                    variant="contained"
                    color="info"
                    size="medium"
                    onClick={() => {
                      onCloseModal();
                    }}
                  >
                    Close
                  </Button>
                </CardActions>
              </Card>
            </form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
}
UOMView.propTypes = {
  itemId: PropTypes.string.isRequired,
  openmodal: PropTypes.string.isRequired,
  onCloseModal: PropTypes.func.isRequired
};

export default UOMView;
